import { createSlice } from "@reduxjs/toolkit";
import {
  getAllSocialMediaLinks,
  createSocialMediaLink,
  updateSocialMediaLink,
  deleteSocialMediaLink,
} from "actions/socialMediaLinks";

const initialState = {
  loading: false,
  items: [],
  createLoading: false,
  savingId: null,
  deletingId: null,
  error: null,
};

export const socialMediaLinksSlice = createSlice({
  name: "socialMediaLinks",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAllSocialMediaLinks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllSocialMediaLinks.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.items = payload;
      })
      .addCase(getAllSocialMediaLinks.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });

    builder
      .addCase(createSocialMediaLink.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createSocialMediaLink.fulfilled, (state) => {
        state.createLoading = false;
      })
      .addCase(createSocialMediaLink.rejected, (state, { payload }) => {
        state.createLoading = false;
        state.error = payload;
      });

    builder
      .addCase(updateSocialMediaLink.pending, (state, { meta }) => {
        state.savingId = meta.arg.id;
        state.error = null;
      })
      .addCase(updateSocialMediaLink.fulfilled, (state, { payload }) => {
        state.savingId = null;
        const index = state.items.findIndex((item) => item.id === payload.id);
        if (index !== -1) state.items[index] = payload;
      })
      .addCase(updateSocialMediaLink.rejected, (state, { payload }) => {
        state.savingId = null;
        state.error = payload;
      });

    builder
      .addCase(deleteSocialMediaLink.pending, (state, { meta }) => {
        state.deletingId = meta.arg;
        state.error = null;
      })
      .addCase(deleteSocialMediaLink.fulfilled, (state, { meta }) => {
        state.deletingId = null;
        state.items = state.items.filter((item) => item.id !== meta.arg);
      })
      .addCase(deleteSocialMediaLink.rejected, (state, { payload }) => {
        state.deletingId = null;
        state.error = payload;
      });
  },
});

export const { clearError } = socialMediaLinksSlice.actions;

export default socialMediaLinksSlice.reducer;
